export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtIbskod';
export const NAME = 'ModelOv';
